module.exports = __webpack_public_path__ + "static/media/Rohan Advani.c9dd4468.jpg";